import { imageService } from '~/services/image.service';
import { useAuthStore } from '~/store/auth';

export const uploadImage = async (fileData: string | ArrayBuffer | null): Promise<string> => {
  const { currentOrganization } = storeToRefs(useAuthStore());
  if (!currentOrganization.value) {
    $notifier.showError({ content: '組織が選択されていません' });
    return '';
  }
  const { result, error } = await imageService.uploadImage(fileData, currentOrganization.value.id);
  if (error) {
    $notifier.showError({ content: '画像のアップロードに失敗しました' });
    return '';
  }
  return result.data.url;
};
